<template>
  <form
    class="pthv-form pthvSchedule-form form"
    method="post"
    @submit.prevent="$emit('nextDepartureClick', selectedData)"
  >
    <div>
      <div class="form-item form-type-select">
      <label class="form-label" for="select-stop">{{ $t("isearchMyStop") }}</label>
        <div class="form-input form-input--type-select has-icon has-icon--end">
          <select
            id="select-stop"
            class="form-select form-input form-input--type-select has-icon has-icon--end form-select--alternative"
            v-model="selectedStop"
            :disabled="isLoading"
            @change="$emit('selectStop', selectedStop)"
            required
          >
            <option value="all">{{ $t("chooseStop") }}</option>
            <option
              v-for="stopRef in stopsRefs"
              v-bind:key="stopRef.refs.join('-')"
              v-bind:value="stopRef.refs"
            >
              <span v-text="htmlSpaces(stopRef.name)"></span>
            </option>
          </select>
          <div class="after">
            <svg class="icon icon--primary icon--md not-actionable" tabindex="-1" role="img" aria-hidden="true" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.29289 8.29289C5.68342 7.90237 6.31658 7.90237 6.70711 8.29289L12 13.5858L17.2929 8.29289C17.6834 7.90237 18.3166 7.90237 18.7071 8.29289C19.0976 8.68342 19.0976 9.31658 18.7071 9.70711L12.7071 15.7071C12.3166 16.0976 11.6834 16.0976 11.2929 15.7071L5.29289 9.70711C4.90237 9.31658 4.90237 8.68342 5.29289 8.29289Z" fill="currentColor"></path></svg>
          </div>
        </div>
      </div>
    </div>

    <div class="schedule-select-stop-dates">
      <div class="form-item form-item-date form-type-date js-form-item js-form-item-date js-form-type-date">
        <label class="small-label form-label" for="date">{{ $t("chooseDate") }}</label>
        <div class="form-input form-input--type-date">
          <input
            type="date"
            id="date"
            class="form-date"
            name="date"
            v-model="selectedDate"
            :disabled="isLoading"
            :min="minDate"
            :max="maxDate"
            required
          />
        </div>
      </div>

      <div class="form-item form-item-time form-type-date js-form-item js-form-item-time js-form-type-date">
        <label class="small-label form-label" for="time">{{ $t("chooseTime") }}</label>
        <div class="form-input form-input--type-date">
          <input
            type="time"
            id="time"
            name="time"
            v-model="selectedTime"
            :disabled="isLoading"
            required
          />
        </div>
      </div>
    </div>

      <button type="submit" :disabled="selectedStop === 'all'" :aria-controls="ariaControlItemId" class="button button--primary js-form-submit form-submit button--lg button--icon-end">
        <span>{{ $t("nextTrips") }}</span>
        <svg class="icon icon--primary icon--lg not-actionable" tabindex="-1" role="img" aria-label="" aria-hidden="true" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M11.2929 4.29289C11.6834 3.90237 12.3166 3.90237 12.7071 4.29289L19.7071 11.2929C20.0976 11.6834 20.0976 12.3166 19.7071 12.7071L12.7071 19.7071C12.3166 20.0976 11.6834 20.0976 11.2929 19.7071C10.9024 19.3166 10.9024 18.6834 11.2929 18.2929L16.5858 13H5C4.44772 13 4 12.5523 4 12C4 11.4477 4.44772 11 5 11H16.5858L11.2929 5.70711C10.9024 5.31658 10.9024 4.68342 11.2929 4.29289Z" fill="currentColor"></path></svg>
      </button>
  </form>
</template>

<script>
export default {
  name: "ApthScheduleSelectStop",
  data() {
    let today = new Date();
    let dd = String(today.getDate()).padStart(2, "0");
    let mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
    let yyyy = today.getFullYear();

    let strToday = yyyy + "-" + mm + "-" + dd;
    let strNow =
      String(today.getHours()).padStart(2, "0") +
      ":" +
      String(today.getMinutes()).padStart(2, "0");

    return {
      selectedStop: "all",
      selectedDate: strToday,
      selectedTime: strNow,
    };
  },
  computed: {
    stopsRefs: function () {
      return this.parseStops(this.stops);
    },
    selectedData: function () {
      // let today = new Date();
      // let strNow = String(today.getHours()).padStart(2, '0') + ":" + String(today.getMinutes()).padStart(2, '0')+ ":00";
      // let time = strNow;
      // if (this.selectedTime){
      //   time = this.selectedTime + ":00"; // the expected return format is with seconds
      // }
      let data = {
        stop: this.selectedStop,
        date: this.selectedDate,
      };
      if (this.selectedTime) {
        data.time = this.selectedTime + ":00"; // the expected return format is with seconds
      }
      return data;
    },
  },
  props: {
    stops: {
      type: Array,
      required: true,
      default: () => {
        return [];
      },
    },
    ariaControlItemId: {
      type: String,
      required: false,
      default: null,
    },
    isLoading: {
      type: Boolean,
      required: false,
      default: true,
    },
    minDate: {
      type: String,
      required: false,
      default: null,
    },
    maxDate: {
      type: String,
      required: false,
      default: null,
    },
  },
  watch: {
    stopsRefs(newStopsRefs, oldStopsRefs) {
      // When list of stops refs is changing, set 'all' as default value
      this.selectedStop = "all";
    },
  },
  methods: {
    parseStops(stops) {
      let stopRefs = [];
      for (const stop of stops) {
        if (stop.StopName) {
          let label = stop.StopName.value;
          let name = label.toUpperCase();
          let refs = stopRefs[name] ? stopRefs[name].refs : []; // previous with same name
          /* refs = refs.concat(stop.spoints ? Object.keys(stop.spoints) : [stop.StopPointRef]); */
          refs = refs.concat([stop.StopPointRef]);
          refs = [...new Set(refs)]; // unique
          stopRefs[name] = { name: label, refs: refs };
        }
      }
      return Object.values(stopRefs);
    },
    htmlSpaces(txt) {
      // permet de préserver les successions d'espaces dans le select>options (PWE-491)
      txt = txt.replace(/ /g, "\u00a0");
      return txt;
    },
  },
};
</script>
